module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-header"
  }, [_c('header', [_c('div', {
    staticClass: "header-container"
  }, [_vm._m(0), _vm._v(" "), _c('ul', _vm._l((_vm.navList), function(item, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.changeLanguage(index)
        }
      }
    }, [(_vm.curNavIndex === item.curIndex) ? _c('div', {
      class: {
        current: true
      }
    }, [_c('router-link', {
      attrs: {
        "to": item.linkUrl
      }
    }, [_vm._v("\n                   " + _vm._s(item.text) + "\n                 ")])], 1) : _c('div', {
      class: {
        current: false
      }
    }, [_c('router-link', {
      attrs: {
        "to": item.linkUrl
      }
    }, [_vm._v("\n                   " + _vm._s(item.text) + "\n                 ")])], 1)])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/logo.png"),
      "alt": "",
      "title": "",
      "width": "100%;"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0149c427"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 127
// module chunks = 1